import React from "react";
import "./AppStore.css";

const AppStore = ({ locale = "en", inverted = false }) => {
  const isFrench = locale === "fr";
  const href = isFrench
    ? "https://apps.apple.com/ca-fr/app/mnezy/id1513672558"
    : "https://apps.apple.com/ca/app/mnezy/id1513672558";
  const label = isFrench ? "Voir dans l’App Store" : "View on the App Store";

  return (
    <a className={`app-store-cta${inverted ? " app-store-cta--inverted" : ""}`} href={href} target="_blank" rel="noreferrer">
      <span>{label}</span>
      <span aria-hidden="true">↗</span>
    </a>
  );
};

export default AppStore;
